/* __next_internal_client_entry_do_not_use__ SDUITypographySuffixRenderer auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@faire/web--source/slate/Button";
import React from "react";
import { useSDUIOnClickHandler } from "@faire/retailer/components/SDUI/__internal__/ActionHandler/useSDUIOnClickHandler";
import { ComponentLoggingEventParams } from "@faire/retailer/components/SDUI/__internal__/types";
export var SDUITypographySuffixRenderer = function(param) {
    var suffixCTA = param.suffixCTA, onClickActions = param.onClickActions, link = param.link, loggingData = param.loggingData, color = param.color;
    var onClickHandler = useSDUIOnClickHandler(onClickActions, loggingData !== null && loggingData !== void 0 ? loggingData : ComponentLoggingEventParams.build({}));
    return /*#__PURE__*/ _jsx(Button, {
        variant: "tertiary",
        onClick: onClickHandler,
        linkTo: link,
        tertiaryColor: color,
        children: suffixCTA
    });
};
